import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCpu, FiGift, FiShield } from 'react-icons/fi';
import type { IconType } from 'react-icons';

const FEATURES: Array<{ icon: IconType; label: string }> = [
  { icon: FiShield, label: 'Private, no-upload conversion' },
  { icon: FiCpu, label: 'Local FFmpeg processing' },
  { icon: FiGift, label: 'Free video converter' },
];

const container = { hidden: {}, show: { transition: { staggerChildren: 0.1 } } };
const item = { hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } };

const Hero = () => (
  <section aria-label="Introduction" className="text-center py-14 px-4 max-w-3xl mx-auto">
    <motion.div variants={container} initial="hidden" animate="show">
      <motion.div variants={item}>
        <span className="inline-block text-xs font-bold tracking-widest uppercase text-teal-700 dark:text-lime-200 bg-teal-50 dark:bg-teal-950/40 px-4 py-1.5 rounded-full mb-6 border border-teal-200 dark:border-teal-800">
          Free · Private · No uploads
        </span>
      </motion.div>
      <motion.h1
        variants={item}
        className="text-4xl md:text-6xl font-black mb-5 text-slate-900 dark:text-white leading-tight tracking-tight text-balance"
      >
        Free Batch Video Converter for{' '}
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-teal-600 to-lime-500">
          MP4, MOV, WEBM, MKV, AVI, M4V & GIF
        </span>
      </motion.h1>
      <motion.p
        variants={item}
        className="text-lg md:text-xl text-slate-500 dark:text-slate-400 mb-4 max-w-2xl mx-auto leading-relaxed"
      >
        Convert MP4, MOV, WEBM, MKV, AVI, M4V and GIF in bulk, directly in your browser.
        Your videos stay local, with no uploads, accounts, or server processing.
      </motion.p>
      <motion.p
        variants={item}
        className="text-sm text-slate-400 dark:text-slate-500 mb-10 max-w-xl mx-auto"
      >
        Supports <strong className="text-slate-600 dark:text-slate-300">MP4 · MOV · WEBM · MKV · AVI · M4V · GIF</strong> with compression and resolution settings.
      </motion.p>
      <motion.div variants={item} className="flex flex-wrap justify-center gap-3">
        {FEATURES.map(({ icon, label }, i) => (
          <div key={i} className="flex items-center gap-2 text-sm font-medium text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-800/80 py-2 px-4 rounded-full shadow-sm border border-slate-200 dark:border-slate-700">
            <SafeIcon icon={icon} className="text-lime-600 dark:text-lime-300 shrink-0" />
            <span>{label}</span>
          </div>
        ))}
      </motion.div>
    </motion.div>
  </section>
);

export default Hero;
